import React from 'react';
import { useHistory } from 'react-router-dom';
import { Row, Typography, Card, Avatar, Button } from 'antd';
import { GoClock } from 'react-icons/go';
import moment from 'moment';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import i18n from 'i18next';

import { AcceptOrderHandler } from '../cookscomponent/AcceptOrder';
import { OrderRefuseModalHandler } from './OrderRefused';
import { orderAcceptedModalHandler } from './OrderAccepted';

import { Orders } from '../../../store/orders/types';
import { getScheduleTime } from '../../userprofile/components/FoodList';

export interface CoverImageProps {
  image?: string;
  price?: string;
  title?: string;
  portions?: string;
}

export interface DetailsButtonProps {
  onclick?: (e?: React.MouseEvent) => void;
}

export interface NewOrdersProps {
  isGuest: boolean;
  meal: Orders;
}

export const CoverImageDetails: React.FC<CoverImageProps> = ({
  image,
  price,
  title,
  portions,
}) => {
  return (
    <div className="orders-cover-image">
      <div className="cover-image-overlay" />
      <img alt="example" src={image} />
      <div className="cover-image-bottomleft-items">
        {portions !== '' ? (
          <Typography.Text className="title-text" ellipsis>
            {portions}x
          </Typography.Text>
        ) : null}{' '}
        <Typography.Text className="title-text" ellipsis>
          {title}
        </Typography.Text>
      </div>
      {/* <div className="cover-image-bottom-items">
        <span>{`Kč ${price}`}</span>
      </div> */}
    </div>
  );
};

export const DetailsButton: React.FC<DetailsButtonProps> = ({ onclick }) => {
  return (
    <Button
      type="primary"
      shape="round"
      className="details-button"
      onClick={onclick}
    >
      {i18n.t('DETAILS')}
    </Button>
  );
};

export const orderTimeDifference = (consumptiondate: object) => {
  const seconds = _.get(consumptiondate, 'seconds');
  const orderdatetime = moment.unix(seconds);
  const currentdatetime = moment();
  // console.log('wew', currentdatetime.diff(orderdatetime, 'minutes') >= 2);
  return currentdatetime.diff(orderdatetime, 'minutes') >= 120;
};

export const arriveTimeDifference = (consumptiondate: object) => {
  const seconds = _.get(consumptiondate, 'seconds');
  const orderdatetime = moment.unix(seconds);
  const currentdatetime = moment();
  const arrivalMinutes = orderdatetime.diff(currentdatetime, 'minutes');
  const formatTime = moment
    .utc()
    .startOf('day')
    .add({ minutes: arrivalMinutes })
    .format(`H:mm`);
  if (arrivalMinutes <= 60) {
    const formatMinutes =
      arrivalMinutes <= 0
        ? ''
        : `${
            arrivalMinutes > 1
              ? `${arrivalMinutes} mins`
              : `${arrivalMinutes} min`
          }`;
    return formatMinutes;
  }
  const formatHours = formatTime;
  return formatHours;
};

export const NewOrders: React.FC<NewOrdersProps> = ({ isGuest, meal }) => {
  const history = useHistory();
  const ArriveTime = arriveTimeDifference(meal.consumptiondate);
  const getFirstSchedule = _.head(meal.schedule);
  const getFirstScheduleTime = _.head(getFirstSchedule?.time);
  const time = getScheduleTime(getFirstScheduleTime);
  const newmealitems = {
    ...meal,
    isOrder: true,
    ArriveTime,
    isGuest,
    time,
  };
  const navigate = () => {
    history.push({
      pathname: '/orderdetails',
      state: {
        ...newmealitems,
      },
    });
  };

  const handleOnClick = () => {
    if (meal.status === 'waiting' && !isGuest) {
      AcceptOrderHandler(meal, history);
      return;
    }

    if (meal.status === 'refused' && isGuest) {
      OrderRefuseModalHandler(meal, navigate);
      return;
    }
    if (meal.status === 'accepted' && isGuest) {
      orderAcceptedModalHandler(meal, navigate);
      return;
    }

    navigate();
  };
  return (
    <div className="order-container">
      <Row justify="space-between" className="current-orders-container">
        <Row className="icon-container">
          <Avatar src={meal.userdetails.image} size="small" />
          <Typography.Text className="profile-text" ellipsis>
            {meal.userdetails.firstName}
          </Typography.Text>
        </Row>
        <Row className="icon-container">
          <GoClock
            color={
              meal.status === 'waiting' || meal.status === 'refused'
                ? '#D34836'
                : '#00A75A'
            }
            size={15}
          />

          <Typography.Text
            className={
              meal.status === 'waiting' || meal.status === 'refused'
                ? 'time-text-status'
                : 'time-text'
            }
          >
            {meal.status === 'waiting'
              ? i18n.t('Waiting for Accept')
              : meal.status === 'refused'
              ? i18n.t('Refused')
              : isGuest
              ? ArriveTime === ''
                ? i18n.t('Ready')
                : `${i18n.t('Ready in')} ${ArriveTime}`
              : ArriveTime === ''
              ? i18n.t('Ready')
              : `${i18n.t('ARRIVE_IN')} ${ArriveTime}`}
          </Typography.Text>
        </Row>
      </Row>
      <Card
        bordered={false}
        cover={
          <CoverImageDetails
            price={meal.mealprice}
            title={meal.title}
            image={meal.image}
            portions={isGuest ? '' : meal.portions}
          />
        }
        onClick={handleOnClick}
      />
      <DetailsButton onclick={handleOnClick} />
    </div>
  );
};
